module.exports = __webpack_public_path__ + "static/media/odebrecht.ad7946b3.png";